(() => {
  console.log("bundle js loaded");

  function calculatePriceRange() {
    const allPrices = [];

    document.querySelectorAll(".sp-bundle-item").forEach((item) => {
      const radios = item.querySelectorAll('input[type="radio"]');
      console.log(radios, radios.length);
      radios.forEach((r) => {
        const price = Number(r.dataset.price);
        if (!Number.isNaN(price)) allPrices.push(price);
      });
    });

    if (!allPrices.length) return { min: 0, max: 0 };
    console.log(allPrices)
    return {
      min: Math.min(...allPrices),
      max: Math.max(...allPrices),
    };
  }

  function updateBundlePrice() {
    console.log('updating bundle price')
    let total = 0;
    let hasSelection = true;

    document.querySelectorAll(".sp-bundle-item").forEach((item) => {
      const selected = item.querySelector('input[type="radio"]:checked');
      if (!selected) {
        hasSelection = false;
        return;
      }

      const price = Number(selected.dataset.price);
      if (!Number.isNaN(price)) total += price;
    });
    console.log(total, hasSelection);

    const priceEl = document.querySelector("sale-price.h4");
    if (!priceEl) return;

    let priceText;
    if (total === 0) {
      const { min, max } = calculatePriceRange();
      if (min === max) {
        priceText = `$${min.toFixed(2)}`;
      } else {
        priceText = `$${min.toFixed(2)} - $${max.toFixed(2)}`;
      }
    } else {
      priceText = `$${total.toFixed(2)}`;
    }

    const srSpan = priceEl.querySelector(".sr-only");
    if (srSpan) {
      priceEl.innerHTML = `<span class="sr-only">Sale price</span>${priceText}`;
    } else {
      priceEl.textContent = priceText;
    }
  }

  function addBundleToCart() {
    const items = [];

    document.querySelectorAll(".sp-bundle-item").forEach((item) => {
      const selected = item.querySelector('input[type="radio"]:checked');
      if (!selected) return;

      const variantId = Number(selected.dataset.variantId);
      if (!variantId) return;

      items.push({ id: variantId, quantity: 1 });
    });

    if (!items.length) {
      alert("Select at least one item");
      return;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    })
      .then((r) => r.json())
      .then(() => (window.location.href = "/cart"));
  }

  // Handle radio selection with unselect capability
  document.querySelectorAll(".sp-option-box").forEach((label) => {
    label.addEventListener("click", (e) => {
      e.preventDefault();
      console.log('option box clicked')

      const input = label.querySelector("input[type=radio]");
      if (!input) return;

      const wasChecked = input.checked;
      const group = document.querySelectorAll(`input[name="${input.name}"]`);
      
      // Uncheck all in group
      group.forEach((r) => r.checked = false);
      
      // If it wasn't checked before, check it now
      if (!wasChecked) {
        input.checked = true;
      }

      updateBundlePrice();
    });
  });

  document.addEventListener("click", (e) => {
    const btn = e.target.closest('button[name="sp_bundle_add"]');
    if (!btn) return;
    e.preventDefault();
    addBundleToCart();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateBundlePrice);
  } else {
    updateBundlePrice();
  }
})();

document.addEventListener("click", (e) => {
  if (e.target.matches(".sp-expand-content")) {
    e.preventDefault();
    const wrapper = e.target.closest(".sp-description");
    wrapper.querySelector(".sp-description-preview").style.display = "none";
    wrapper.querySelector(".sp-description-detail").style.display = "block";
  }

  if (e.target.matches(".sp-collapse-content")) {
    e.preventDefault();
    const wrapper = e.target.closest(".sp-description");
    wrapper.querySelector(".sp-description-preview").style.display = "block";
    wrapper.querySelector(".sp-description-detail").style.display = "none";
  }
});